// EmailJS runs in the browser — these IDs are public by design.
// .env values override these when present at build/start time.
const emailjsConfig = {
  publicKey:
    process.env.REACT_APP_EMAILJS_PUBLIC_KEY || '7GTpmpVEtLCursn8v',
  serviceId:
    process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_k33cl6o',
  templateId:
    process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'template_x2krzye',
};

export default emailjsConfig;
